import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    betRes: [],
    currentBetRes: [],
    updateBetRes: [],
    gamehistoryRes: [],
    updateBetAutoRes: [],
    oneGamehist: [],
    gamehistRes: [],
    mineHighRollers: [],
    winnerListsRes: [],
    error: "",
}

const betSlice = createSlice({
    name: 'betMine',
    initialState,
    reducers: {
        bet: (state, action) => {
            state.betRes = action.payload
        },
        currentBet: (state, action) => {
            state.currentBetRes = action.payload
        },
        updatebet: (state, action) => {
            state.updateBetRes = action.payload
        },
        updatebetAuto: (state, action) => {
            state.updateBetAutoRes = action.payload
        },
        gamehistory: (state, action) => {
            state.gamehistoryRes = action.payload
        },
        oneGamehist: (state, action) => {
            state.gamehistRes = action.payload
        },
        rareWinnerLists: (state, action) => {
            state.winnerListsRes = action.payload
        },
        highRollersMine: (state, action) => {
            state.mineHighRollers = action.payload
        }
    }
})

export const { bet, currentBet, updatebet, highRollersMine, gamehistory, oneGamehist, updatebetAuto, rareWinnerLists } = betSlice.actions;
export default betSlice.reducer;

export const betMines = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.BET_API}`, data);
            callback(response)
            dispatch(bet(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getCurrenctBet = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_CURRENT_BET}`, data);
            callback(response)
            dispatch(currentBet(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const updateBet = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.UPDATE_MINE_GAME}`, data);
            callback(response)
            dispatch(updatebet(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

// Demo
export const getgamehistory = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_GAME_HISTORY}`, data);
            callback(response)
            dispatch(gamehistory(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }


export const getoneGamehist = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.USER_GAME_HISTORY}`, data);
            callback(response)
            dispatch(oneGamehist(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const updateBetAuto = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.UPDATE_MINE_GAME_AUTO_MODE}`, data);
            callback(response)
            dispatch(updatebetAuto(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }


export const winnerList = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_RARE_WINNERS}`, data);
            callback(response)
            dispatch(rareWinnerLists(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getMineHighRollers = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_HIGH_MINE_ROLLERS}`, data);
            callback(response)
            dispatch(highRollersMine(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }